import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectAllPositions, aggregatePositionsByTeamId } from '../slice'

export const usePositionsBySalesTeamId = (salesTeamId: number) => {
  const positions = useSelector(selectAllPositions)
  const filtered = useMemo(
    () => aggregatePositionsByTeamId(salesTeamId, positions),
    [positions, salesTeamId],
  )
  return filtered
}
